import { render, staticRenderFns } from "./s2b2c.vue?vue&type=template&id=2191fd16&scoped=true"
import script from "./s2b2c.vue?vue&type=script&lang=js"
export * from "./s2b2c.vue?vue&type=script&lang=js"
import style0 from "./s2b2c.vue?vue&type=style&index=0&id=2191fd16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2191fd16",
  null
  
)

export default component.exports